import React from 'react';
import Button from '@mui/material/Button';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import TaskIcon from '@mui/icons-material/Task';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default class CopyButton extends React.Component{
    constructor(props) {
        super(props);
        this.txt = this.props.txt;
        this.onMouseClick = this.onMouseClick.bind(this);
        this.state = {
            color: 'action',
            disable: false,
        }
    }
    onMouseEnter() {
        this.setState({ color: 'primary' });
    }
    onMouseLeave() {
        this.setState({ color: 'action' });
    }
    onMouseClick() {
        this.setState({ disable: true});
        this.setState({ color: 'action' });
        setTimeout(() => this.setState({ disable: false }), 3000);
        //return this.props.onMouseClick();
    }
    render() {
    return(
    <CopyToClipboard text={this.txt}>  
    <Button data-tip data-for="copyTip" data-delay-hide={1000} disabled = {this.state.disable}
        style={{ maxWidth: "20px", maxHeight: "20px", minWidth: "15px", marginRight: "0px", marginLeft: "0px", padding: "0px,0px" }}
        onClick={(e) => { e.stopPropagation(); this.onMouseClick(); } }
        onMouseEnter = {() => this.onMouseEnter()}
        onMouseLeave = {() => this.onMouseLeave()}
        >{this.state.disable ? (<TaskIcon sx={{ color: '#4caf50' }} fontSize="small" />):
        (<FileCopyIcon color={this.state.color} fontSize="small" />)}
    </Button>
    </CopyToClipboard>
    );
    }
}